import { Helper } from '../Helper';
export class IsHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'PICKITEM');
        sb.emitPushInt(node, this.type);
        sb.emitOp(node, 'NUMEQUAL');
    }
}

//# sourceMappingURL=IsHelper.js.map
